<template>
  <div id="app">
    <Sidebar/>
    <ContentHeader/>
    <router-view :key="$route.path"/>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import Sidebar from '@/components/Sidebar.vue';
import ContentHeader from '@/components/ContentHeader.vue';

export default {
  name: 'home',
  components: {
    Sidebar, ContentHeader,
  },
  data() {
    return {
    };
  },
  methods: {
    ...mapActions([
      'chSignIn',
    ]),
  },
  mounted() {
    this.chSignIn(this.$session.exists());
  },
};
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,600,700&display=swap');

  .ps__rail-y, .ps__rail-x{
    z-index: 91;
  }

  body{
    margin: 0; padding: 0;
    font-family: 'Source Sans Pro', sans-serif;
    color: #444;
  }
  input, textarea{
    font-family: 'Source Sans Pro', sans-serif;
    color: #444;
  }
  a{
    text-decoration: none;
    color: #0747a6;
  }
  p{ margin: 0;  }
  #app{
    display: flex;
    min-height: 100vh;
    .content{
      padding: 30px;
      padding-top: 0;
      margin-top: 48px;
      flex-grow: 1;
      padding-bottom: 0;
      box-sizing: border-box;
      height: calc(100vh - 48px);
      overflow: auto;
      width: calc(100vw - 300px);
    }
  }
  input{
    box-sizing: border-box;
  }
  input.vc-text-base{
    border-color: #ccc;
    color: #444;
    padding: 12px;
  }

  .tdAction{
    width: 50px;
  }

  .fieldGroup{
    margin-bottom: 20px;
  }
  .fieldError{
    color: red;
    font-size: 13px;
    padding: 4px 0 0 10px;
    display: none;
    text-align: left;
  }
  .fieldGroup.hasError{
    .field{
      border-color: red;
    }
    .fieldError{
      display: block;
    }
    .fieldHint{
      display: none;
    }
  }
  .fieldCnt.hasError{
    .field{
      border-color: red;
    }
    .fieldError{
      display: block;
    }
    .fieldHint{
      display: none;
    }
  }
  .fieldHint{
    color: #767676;
    font-size: 13px;
    text-align: left;
    margin: 4px 0 0 10px;
  }
  .fieldGroup .fieldGroup1,
  .fieldGroup .fieldGroup2{
    float: left;
    width: 50%;
  }
  .fieldGroup .fieldGroup1 .field{
    border-radius: 10px 0 0 10px;
  }
  .fieldGroup .fieldGroup2 .field{
    border-radius: 0 10px 10px 0;
  }
  .fieldGroup label{
    display: block;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 14px;
    color: #999;
    margin-bottom: 4px;
    padding-left: 7px;
  }
  .field{
    display: block;
    padding: 12px;
    width: 100%;
    box-sizing: border-box;
    border-radius: 5px;
    border: #ccc 1px solid;
    outline: 0 !important;
    font-size: 17px;
    color: #2d3748;
    position: relative;
    background-color: #fff;
    z-index: 1;
    font-family: 'Source Sans Pro', sans-serif;
    &:hover{
      border-color: #222;
    }
    &.hasError{
      border-color: red;
    }
  }
  .field:focus{
    border-color: #065feb;
    z-index: 2;
  }

  .btn{
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    font-weight: bold;
    font-size: 18px;
    outline: 0 !important;
    cursor: pointer;
    transition: all .2s ease;
  }
  .btn.btnLg{
    font-size: 20px;
    padding: 12px 24px;
  }
  .btnPrimary{
    background-color: #0057d8;
    color: #fff;
    &:focus{
      outline: #fff 2px solid !important;
      box-shadow: 0 0 0px 3px #0057d8;
    }
    &:hover{
      background-color: #0067ff;
      box-shadow: 2px 2px 4px rgba(0,0,0,.1);
    }
  }
  .btnSecondary{
    background: none;
    color: #0747a6;
    &:hover{
      background-color: #fff;
      box-shadow: 2px 2px 4px rgba(0,0,0,.1);
    }
  }
  .clear{
    clear: both;
  }

  [placeholder]:empty::before {
    content: attr(placeholder);
    color: #999;
  }
  [placeholder]:empty:focus::before {
    content: "";
  }

  @import url('https://fonts.googleapis.com/css?family=Overpass:300,600,700,800&display=swap');

  .modalContent{
    transition: all .2s ease;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: all .2s ease;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
    .modalContent{
      transform: scale(.9);
    }
  }

  .pageEditorContent{
    position: relative;
    font-family: 'Overpass', sans-serif;
    background-color: #fff;
    color: #444;
    font-size: 16px;
    padding-top: 60px;

    .settingBtn{
      position: absolute;
      right: 20px; top: 20px;
      width: 34px; height: 34px;
      border-radius: 50%;
      z-index: 3;
      background-image: url(assets/settings-white.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      &:hover{
        background-color: rgba(0,0,0,.2);
        cursor: pointer;
      }
    }
    .theMain{
      .settingBtn{
        top: 80px;
      }
    }

    a{
      color: #0089ff;
      &:hover{
        color: #0028c7;
      }
    }

    .container{
      max-width: 960px;
      margin: 0 auto;
    }

    .i.i-marker{
      display: inline-block;
      width: 18px;
      height: 18px;
      background-image: url(assets/marker.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .6;
    }
    [contenteditable="true"] {
      border: transparent 1px dashed;
      outline: 0;
      border-radius: 5px;
      &:hover{
        background-color: #f5f9ff;
        border-color: #8ebbff;
      }
      &.pageTitle{
        padding: 10px 0 0px;
      }
      &.pageSubtitle{
        padding: 10px;
      }
      &.psInfo2{
        padding: 10px;
        margin-bottom: 5px;
      }
      &:focus{
        background-color: #e7f1ff;
        border-color: #0747a6;
      }
      &.contactInfo{
        padding: 10px;
        margin: -10px -10px 0;
        &:hover{
          background-color: rgba(255,255,255,.1);
        }
        &:focus{
          background-color: rgba(255,255,255,.2);
          color: #fff;
        }
      }
    }
    .c-feature-grid__item{
      h3, p{
        box-sizing: border-box;
        max-width: 100%;
      }
      h3{
        margin: 10px -10px 0 !important;
        padding: 4px 10px 2px;
      }
      p{
        padding: 6px 10px;
        margin-left: -10px !important;
      }
    }
    .mainContent, .pageHeader{
      h2{
        padding: 12px 14px 0;
        margin-left: -14px !important;
        &:hover{
          background-color: rgba(0,0,0,.1);
          border-color: rgba(0,0,0,.3);
        }
        &:focus{
          background-color: rgba(0,0,0,.2);
          border-color: rgba(0,0,0,.5);
        }
      }
      p{
        margin-left: -14px !important;
        padding: 8px 14px 6px;
        &:hover{
          background-color: rgba(0,0,0,.1);
          border-color: rgba(0,0,0,.3);
        }
        &:focus{
          background-color: rgba(0,0,0,.2);
          border-color: rgba(0,0,0,.5);
        }
      }
    }

    .clear{
      clear: both;
    }

    .dataEmptyCnt{
      position: relative;
      height: calc(100vh - 49px);
    }
    .submissionEmpty{
      text-align: center;
      position: absolute;
      left: 50%; top: 50%;
      transform: translate(-50%, -50%);
      h4{
        margin: 0;
        font-size: 32px;
        color: #767676;
        font-weight: normal;
        margin-bottom: 10px;
      }
      p{
        font-size: 15px;
        color: #767676;
        margin-bottom: 30px;
      }
      .btn{
        // border: #0747a6 2px solid;
        border-radius: 50px;
      }
      .emptyImg{
        width: 360px; height: 360px;
        background-image: url(assets/trash-empty.png);
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        margin: 0 auto 20px;
      }
    }

    .menuCnt{
      float: right;
      padding-top: 10px;
      transition: all .2s linear;
    }
    .menuCnt .btn{
      margin-left: 20px;
      border-radius: 50px;
    }

    .menuCnt{
      a, span{
        text-decoration: none;
        color: #444;
        margin-left: 20px;
      }
    }
    .logoCnt{
      transition: all .2s linear;
      font-size: 24px;
      font-weight: bold;
      padding: 16px 0;
      margin-left: -10px;
      position: relative;
      z-index: 2;
      display: inline-block;
      color: #444;
      letter-spacing: -1px;
    }
    .logoCnt .logo{
      width: 130px;
      height: 50px;
      background-image: url(assets/logo.jpg);
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      margin-top: -12px;
      margin-right: 8px;
      float: left;
    }

    header.scrolled{
      box-shadow: 0 0 6px rgba(0,0,0,.2);
      height: 50px;
    }
    header.scrolled .menuCnt{
      padding-top: 5px;
    }
    header.scrolled .logoCnt{
      padding: 11px 0 0;
    }

    @media (max-width: 767px){
      #bg{
        display: none;
      }
      header{
        z-index: 9;
      }
    }

    .whatsNew{
      text-align: center;
      border-top: #eee 1px solid;
      padding: 60px 0;
    }
    .whatsNewCnt{
      text-align: left;
    }
    .whatsNewItem{
      float: left;
      width: 25%;
    }
    .wnIn{
      padding: 0 20px;
    }
    .whatsNewItem .itemImg{
      height: 180px;
      background-color: #eee;
      border-radius: 10px;
      background-size: cover;
      background-position: center;
      margin-bottom: 10px;
    }
    .whatsNewItem{
      .newsSk1, .newsSk2, .newsSk3{
        background-color: #eee;
        height: 20px;
        width: 80%;
        border-radius: 4px;
        margin-bottom: 8px;
      }
      .newsSk2{
        width: 100%;
      }
      .newsSk3{
        width: 60%;
      }
    }


    .pageTitle{
      margin: 0;
      font-size: 40px;
      font-weight: bold;
      text-align: center;
    }
    .pageSubtitle{
      margin: 0 auto;
      text-align: center;
      font-size: 18px;
      max-width: 800px;
      margin-bottom: 40px;
    }


    .psImage{
      // float: left;
      width: 60%;
      margin: 0 auto;
    }
    .psImage img{
      width: 100%;
    }
    .psInfo{
      // width: 40%;
      // float: left;
      // padding-top: 120px;
      text-align: center;
      max-width: 900px;
      margin: 0 auto;
    }
    .psInfo .btn{
      margin-right: 10px;
    }
    .btnOne,
    .btnTwo{
      color: #fff;
      border: none;
      background-color: #8b2385;
    }
    .btnOne:hover{
      background-color: #b320aa;
    }
    .btnTwo{
      background-color: #f16f22;
    }
    .btnTwo:hover{
      background-color: #ff863f;
    }

    .whyCnt{
      padding: 50px 0;
      text-align: center;
    }
    .theList{
      width: 40%;
      float: left;
      text-align: left;
    }
    .c-feature-grid__item{
      img{
        height: 50px;
      }
      h3{
        font-size: 20px;
        margin: 10px 0 5px;
        margin-top: 0 !important;
      }
      p{
        margin: 0 auto;
        margin-bottom: 20px;
        font-size: 15px;
      }
    }
    .whyVideo{
      width: 60%;
      float: left;
    }
    .theVideo{
      width: calc(100% - 20px);
      margin-left: 20px;
      margin-top: 90px;
      height: 340px;
      background-color: #eee;
      border-radius: 10px;
      background-size: cover;
      background-position: center;
      position: relative;
    }
    .playIcon{
      position: absolute;
      width: 100px;
      left: 50%; top: 50%;
      transform: translate(-50%, -50%);
      color: #fff;
      font-size: 11px;
      cursor: pointer;
      opacity: .5;
    }
    .playIcon:hover{
      opacity: 1;
    }
    .playIcon .theIcon{
      width: 60px; height: 50px;
      margin: 0 auto;
      margin-bottom: 10px;
      background-image: url(assets/play.png);
      background-size: 24px auto;
      background-position: center;
      background-repeat: no-repeat;
      border: #fff 2px solid;
      border-radius: 5px;
    }

    .btn{
      padding: 10px 18px;
      font-size: 17px;
      font-weight: bold;
      cursor: pointer;
      border-radius: 5px;
      outline: 0 !important;
      display: inline-block;
      text-decoration: none;
      line-height: 1.4;
    }
    .btnOutline{
      background-color: transparent;
      border: #fff 2px solid;
      color: #fff;
    }
    .btnOutline:hover{
      color: #f17021;
      border-color: #f17021;
    }
    .btn:hover{
      box-shadow: 2px 2px 6px rgba(0,0,0,.2);
    }

    .productsSolutions{
      padding: 60px 0;
      border-top: #eee 1px solid;
    }

    .theMain{
      position: relative;
      height: 560px;
      margin-top: 0;
      padding-top: 60px;
    }
    .theMain .content{
      position: relative;
      z-index: 2;
      height: 100%;
    }
    .theMain .mainContent{
      position: absolute;
      left: 0; top: 50%;
      transform: translateY(-50%);
      max-width: 800px;
    }
    .theMain .content h2{
      color: #fff;
      margin: 0;
      font-size: 50px;
      line-height: 1;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .theMain .content p{
      color: #fff;
      margin: 0;
      font-size: 18px;
      line-height: 1.2;
      font-weight: lighter;
      margin-bottom: 20px;
    }
    #loading, #bg, #particles-js{
      position: absolute;
      top: 0; right: 0; bottom: 0; left: 0;
      z-index: 0;
    }
    #loading{
      position: fixed;
    }
    #particles-js{
      z-index: 1;
      background: linear-gradient(to left, #F27121, #E94057, #8A2387);
    }
    #app{
      position: relative;
      z-index: 2;
    }
    #loading{
      z-index: 3;
      background-color: #fff;
      transition: all .3s ease;
    }
    .loadingLogo{
      position: absolute;
      width: 110px;
      height: 110px;
      top: 50%; left: 50%;
      background-image: url(assets/logo.jpg);
      background-position: center;
      background-size: 70px auto;
      background-repeat: no-repeat;
      border: #f5851d 2px solid;
      border-radius: 50%;
      margin: -55px;
      text-align: center;
      font-size: 20px;
      color: #f5871d;
      font-weight: bold;
    }
    .loadingLogo span{
      display: block;
      margin-top: 120px;
    }
    #loading.loadedd{
      opacity: 0;
    }


    .footer{
      background-color: #f5f5f5;
      color: #767676;
    }
    .footerMenu{
      padding: 60px 0px 40px;
    }
    .footerMenuItem{
      float: left;
      width: 25%;
      a{
        color: #fff;
        text-decoration: none;
      }
      p{
        margin: 0;
        margin-bottom: 5px;
        font-size: 14px;
      }
    }
    .footerMenu h4{
      margin: 0;
      margin-bottom: 15px;
      font-size: 15px;
      padding: 6px 10px 4px;
      margin-left: -10px;
      margin-right: 20px;
      &:hover{
        background-color: rgba(255,255,255,.1);
      }
      &:focus{
        color: #fff;
        background-color: rgba(255,255,255,.2);
      }
    }
    .footerMenu li{
      list-style: none;
      padding-bottom: 4px;
      a, span{
        color: #fff;
        opacity: .8;
        text-decoration: none;
        font-size: 14px;
      }
      span{
        background-color: #fff;
        border-radius: 3px;
        opacity: .2;
      }
      a:hover{
        opacity: 1;
      }
    }
    .footerCopyright{
      // border-top: rgba(255,255,255,.1) 1px solid;
      padding: 20px 0 16px;
      font-size: 13px;
      span{
        padding: 6px 4px;
        &:hover{
          color: #444;
        }
        &:focus{
          color: #222;
        }
      }
    }
    .footerCopyright a{
      color: #fff;
      margin: 0 10px;
      text-decoration: none;
    }
    ._sew69u{
      float: right;
      margin-top: -8px;
    }
    ._sew69u span{
      float: left;
      margin-left: 10px;
    }

    .content{
      width: 900px;
      margin: 0 auto;
      padding: 0 !important;
    }
    .button{
      border: none;
      background-color: #f26f1e;
      padding: 12px 20px;
      border-radius: 4px;
      font-size: 17px;
      font-weight: bold;
      color: #fff;
      box-shadow: 2px 2px 2px rgba(0,0,0,0.2);
      background-image: linear-gradient(to right, #f25f1f, #f8931f);
      outline: 0 !important;
      cursor: pointer;
      text-decoration: none;
    }
    .button:hover{
      background-image: linear-gradient(to right, #f14900, #f99f39);
    }
    .button:active{
      box-shadow: none;
      background: #f14900;
    }
    .button.disabled{
      color: #7b2500;
      background: #f14900;
      box-shadow: none;
    }
    ._404Cnt{
      max-width: 600px;
        margin: 0 auto;
        text-align: center;
    }
    ._404Cnt img{
      max-width: 80%;
    }
    .backToHomeCnt{
      text-align: center;
    }
    .backToHome{
      display: inline-block;
      margin: 4px auto 0;
      position: relative;
      z-index: 9;
    }

    .menuMobileToggle{
      width: 40px;
      height: 40px;
      float: right;
      background-size: 30px auto;
      background-position: center;
      background-repeat: no-repeat;
      margin-left: 20px;
      display: none;
    }
    .menuMobile{
      position: fixed;
      top: 0; right: 0; left: 0; bottom: 0;
      z-index: 99;
      display: none;
    }
    .menuMobileList{
      position: absolute;
      right: 0; top: 0; bottom: 0;
      z-index: 2;
      background-color: #fff;
      right: -300px;
      transition: all .3s ease;
      width: 300px;
      padding-top: 40px;
      box-shadow: 0 0 8px rgba(0,0,0,.2);
    }
    .menuMobileList a{
      display: block;
      color: #444;
      text-decoration: none;
      padding: 10px 30px;
    }
    .menuMobile .overlay{
      position: absolute;
      left: 0; top: 0; right: 0; bottom: 0;
      z-index: 1;
      background-color: rgba(0,0,0,.5);
      opacity: 0;
      transition: all .3s linear;
    }
    .menuMobile.open{
      display: block;
    }
    .menuMobile.open2 .menuMobileList{
      right: 0;
    }
    .menuMobile.open2 .overlay{
      opacity: 1;
    }

    @media(max-width: 1230px){
    .content{
      width: 900px;
    }
      .menuCnt a{
          display: none;
      }
      .menuMobileToggle{
          display: block;
      }
    }

    @media(max-width: 960px){
      .content{
          width: auto;
          padding: 0 20px
      }
      .menuCnt .btn{
          display: none;
      }
      .theMain .content{
          text-align: center;
      }
      .theMain .content h2{
          font-size: 24px;
      }
      .theMain .content p{
          font-size: 14px;
      }
      .theMain .mainContent{
          position: static;
          transform: none;
      }
      .theMain{
          height: auto;
          padding: 80px 0;
      }
      .pageTitle{
          font-size: 30px;
      }
      .pageSubtitle{
          font-size: 15px;
      }
      .whyCnt{
          padding: 40px 0;
      }
      .theList{
          width: auto;
          float: none;
          text-align: center;
      }
      .c-feature-grid__item h3{
          font-size: 18px;
      }
      .c-feature-grid__item p{
          font-size: 14px;
          color: #767676;
      }
      .whyVideo{
          float: none;
          width: auto;
      }
      .theVideo{
          width: auto;
          margin: 0 0 10px 0;
          height: 200px;
      }
      .psImage, .footerMenuItem, .psInfo{
          float: none;
          width: auto;
      }
      .whatsNew, .productsSolutions{
          padding: 40px 0;
      }
      .wnIn{
          padding: 0 0 10px;
      }
      .whatsNewCnt{
          width: 1200px;
          padding-left: 20px;
      }
      .whatsNewItem{
          width: 280px;
          margin-right: 20px;
      }
      .wnSc{
          margin: 0 -20px;
          overflow-x: auto;
      }
      .psInfo{
          padding-top: 0;
          text-align: center;
      }
      .footerMenu{
          padding: 40px 0 20px;
          text-align: center;
      }
      .footerCopyright{
          text-align: center;
      }
      .footerCopyright span{
          display: block;
          margin-top: 10px;
      }
      ._sew69u{
          float: none;
          margin-top: 15px;
      }
      .footerCopyright span{
          display: inline-block;
          float: none;
      }
    }
  }


  .lthHeaderCnt{
    display: flex;
    height: 44px;
    border-bottom: #eee 1px solid;
    margin: 0 -30px;
    padding: 0 30px;
    justify-content: center;
    align-items: center;
    .lBtn{
      width: 34px; height: 34px;
      margin-right: 10px;
      border-radius: 50%;
      cursor: pointer;
      transition: background .3s ease;
      background-size: 18px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .6;
      &:hover{
        opacity: 1;
        background-color: #eee;
      }
      &.refresh{
        background-image: url(assets/reload.png);
      }
      &.selectAll{
        width: 36px; height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        .theSelect{
          width: 13px; height: 13px;
          border: #767676 2px solid;
          border-radius: 4px;
          position: relative;
          .selectIn{
            display: none;
            background-color: red;
            position: absolute;
            left: 0; right: 0; top: 0; bottom: 0;
          }
        }
      }
    }
    .searchCnt{
      margin-left: 10px;
      height: 35px;
      form{
        position: relative;
        height: 100%;
        input{
          width: 360px;
          height: 100%;
          box-sizing: border-box;
          border: #eee 2px solid;
          background-color: #eee;
          border-radius: 50px;
          font-size: 16px;
          padding: 0 36px 0 14px;
          transition: all .3s ease;
          &:hover{
            border-color: #ccc;
          }
          &:focus{
            background-color: #fff;
            border-color: #0057d8;
            box-shadow: 2px 2px 4px rgba(0,0,0,.2);
          }
        }
        button{
          position: absolute;
          right: 4px; top: 1px;
          width: 33px; height: 33px;
          border-radius: 50%;
          border: none;
          background-color: transparent;
          background-image: url(assets/search.png);
          background-size: 16px auto;
          background-position: center;
          background-repeat: no-repeat;
          outline: 0;
          cursor: pointer;
          opacity: .5;
          z-index: 2;
        }
      }
    }
  }
  .pagination{
    color: #767676;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    margin-left: auto;
    .pageInfo{
      margin-right: 6px;
    }
    .pageBtn{
      width: 34px; height: 34px;
      border-radius: 50%;
      margin-left: 2px;
      cursor: pointer;
      transition: background .3s ease;
      background-size: 14px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .6;
      position: relative;
      &.disabled{
        opacity: .3 !important;
        background-color: #fff !important;
        cursor: default;
      }
      &.pagePrev{
        background-image: url(assets/left-arrow.png);
      }
      &.pageNext{
        background-image: url(assets/right-arrow.png);
      }
      &.config{
        background-image: url(assets/settings.png);
        background-size: 18px auto;
      }
      .ddCnt{
        position: absolute;
        right: 0; top: 100%;
        background-color: #fff;
        z-index: 999;
        padding: 10px 0;
        border: #eee 1px solid;
        border-radius: 5px;
        box-shadow: 2px 2px 6px rgba(0,0,0,.2);
        width: 240px;
        cursor: default;
        display: none;
        .ddItem{
          padding: 10px 0;
          h4{
            margin: 0 0 4px;
            padding-left: 20px;
            text-transform: uppercase;
          }
          .radioCnt{
            .radioItem{
              padding: 10px 0;
              padding-left: 50px;
              color: #444;
              font-size: 16px;
              cursor: pointer;
              position: relative;
              .radio{
                width: 18px; height: 18px;
                border-radius: 50%;
                border: #999 2px solid;
                box-sizing: border-box;
                position: absolute;
                left: 20px; top: 11px;
                &.checked{
                  border-color: #2c74bc;
                  &:before{
                    content: "";
                    position: absolute;
                    background-color: #2c74bc;
                    top: 2px; left: 2px; right: 2px; bottom: 2px;
                    border-radius: 50%;
                  }
                }
              }
              &.density{
                padding-top: 4px;
                padding-bottom: 8px;
                .radio{
                  top: 8px;
                }
              }
              &:hover{
                background-color: #f5f5fe;
              }
              img{
                display: block;
                margin-top: 4px;
              }
            }
          }
        }
      }
      &:hover{
        background-color: #eee;
        opacity: 1;
        .ddCnt{
          display: block;
        }
      }
    }
  }

  .tabCnt{
    display: flex;
    border-bottom: #eee 1px solid;
    margin: 0 -30px;
    .tab{
      width: 20%;
      padding: 14px 0;
      padding-left: 56px;
      font-weight: 600;
      font-size: 17px;
      position: relative;
      color: #767676;
      cursor: pointer;
      &:before{
        content: "";
        position: absolute;
        left: 30px; top: 16px;
        width: 16px; height: 16px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .5;
      }
      &:after{
        position: absolute;
        left: 0; right: 0; bottom: 0;
        height: 4px; content: "";
        border-radius: 5px 5px 0 0;
      }
      &:hover{
        background-color: #f5f5f5;
        &:after{
          background-color: #ddd;
        }
      }
      &.active{
        color: #444;
        &:before{
          opacity: .7;
        }
      }
      &.published{
        &:before{
          background-image: url(assets/public.png);
        }
        &.active{
          &:after{
            background-color: #0e5dd2;
          }
        }
      }
      &.unpublished{
        &:before{
          background-image: url(assets/private.png);
        }
        &.active{
          &:after{
            background-color: green;
          }
        }
      }
      &.starred{
        &:before{
          background-image: url(assets/star-black.png);
        }
        &.active{
          &:after{
            background-color: orange;
          }
        }
      }
      &.draft{
        &:before{
          background-image: url(assets/draft-black.png);
        }
        &.active{
          &:after{
            background-color: #444;
          }
        }
      }
      &.product{
        &:before{
          background-image: url(assets/draft-black.png);
        }
        &.active{
          &:after{
            background-color: #8cc43f;
          }
        }
      }
      &.deleted{
        &:before{
          background-image: url(assets/trash-black.png);
        }
        &.active{
          &:after{
            background-color: red;
          }
        }
      }
    }
  }
</style>
